import { Component, Input } from '@angular/core';

/** Card container with an icon + title header and an optional right-aligned caption. */
@Component({
  selector: 'app-section-card',
  standalone: false,
  templateUrl: './section-card.component.html',
  styleUrl: './section-card.component.scss',
})
export class SectionCardComponent {
  @Input({ required: true }) cardTitle = '';
  /** Path to an SVG in assets/icons (e.g. `assets/icons/shield.svg`). */
  @Input() iconPath?: string;
  @Input() caption?: string;
}
